export const SET_LOCALS = 'SET_LOCALS';
